import { defineHTMLForProductImages } from "./quickView/quickViewProdImages";
import { defineHTMLForAddToCartButton } from "./quickView/quickViewCartInteractions";
import { defineHTMLForAddToFavoritesButton } from "./quickView/quickViewFavoritesInteractions";
import { defineHTMLForPricingArea } from "./quickView/quickViewPricing";
import {
    defineHTMLForProductPromotionalBadges,
    defineHTMLForProductGeneralBadges,
    defineHTMLForProductDeliveryBadge } from "./quickView/quickViewBadges";
import {
    defineHTMLForProductSwatches,
    defineHTMLForProductSizes,
    defineHTMLForVariationError} from "./quickView/quickViewVariationsOptions";
import {
    defineHTMLForProductName,
    defineHTMLForProductBrand,
    defineHTMLForProductMeasurement,
    defineHTMLForProductDescription,
    defineHTMLForProductAdditionalInfo,
    defineHTMLForProductRedirect } from "./quickView/quickViewGeneralInformation";
import { filterVariations } from "./quickView/quickViewUtils";

/**
 * Defines the templating for product section
 */
const productTemplating = {
    quickView: data => {
        let quickViewHTML = "";

        if (!data) {
            return quickViewHTML;
        }

        const {product, resources, noImageLarge, separatorResource, brandID, productBrandID, checkoutPage, gtmData} = data;
        const {id, productType } = product;
        const productSalesPrice = product && product.price && product.price.sales ? product.price.sales.value : null;

        product.fallbackImage = noImageLarge;
        product.separatorResource = separatorResource;

        var flexColumns = false;
        const {variationAttributes} = product;
        var colorList = null;

        if (variationAttributes instanceof Array) {
            colorList = filterVariations(variationAttributes, "color");
        }

        const colorObject = colorList && colorList.length ? colorList[0] : null;

        if (colorObject) {
            const {values} = colorObject;
            if (values && values.length > 2) {
                flexColumns = true;
            }
        }

        quickViewHTML =
            `<div class="js-product-quickview row flex-column flex-sm-row no-gutters product-quickview product-${productType} product-wrapper product-detail" data-pid="${id}" data-gtm-index="${gtmData.gtmIndex}" data-gtm-list="${gtmData.gtmList}">
                <div class="col-12 col-sm-5 pr-0 pr-sm-4 product-images--wrapper d-flex justify-content-center h-100"> 
                    ${defineHTMLForProductImages(product)}
                    ${defineHTMLForProductDeliveryBadge(product, productBrandID)}
                </div>

                <div class="col-12 col-sm-7 product-name-details h-100">
                    <div class="product-name-details--wrapper pwc-border--radius">
                        ${defineHTMLForProductPromotionalBadges(product, productBrandID)}
                        ${defineHTMLForProductGeneralBadges(product, productBrandID)}
                        <div class="ct-pdp--name">
                            ${defineHTMLForProductName(product)}
                            ${defineHTMLForProductBrand(product)}
                            ${defineHTMLForProductMeasurement(product)}
                        </div>
                        <div class="row no-gutters pwc-qv--variations-wrapper ${flexColumns ? "pwc-qv--variations-wrapper-columns" : ""}">
                            ${defineHTMLForProductSwatches(product, resources, checkoutPage)}
                            ${defineHTMLForProductSizes(product, brandID, checkoutPage)}
                            ${defineHTMLForVariationError(product, resources)}
                        </div>
                        <div class="prices-add-to-cart-actions mt-0 flex-column no-gutters"
                            data-delay-time="${product.confirmationDelayTime}"
                            data-in-cart-msg="${resources.inCartLabel}"
                            data-one-product-added="${resources.inCartOneProduct}"
                            data-remove-from-cart-msg="${resources.removeFromCartLabel}"
                            data-stay-open="${resources.CONFIRMATION_POPUP_DISPLAY_DURATION}"
                        >   
                            <div class="d-flex align-items-start mt-4 mb-0 mb-sm-4"> 
                                ${defineHTMLForPricingArea(product, resources, checkoutPage, data.addToFavoritesButton)}
                            </div>
                            <div class="row ct-pdp--favorite-addCTA m-0 p-sm-0 col-12 no-gutters">
                                ${!checkoutPage && (productSalesPrice || product.productType == "master") ? `<div class="pdp-more-details col-5 col-md-4 pr-3 pr-sm-0 mr-3 d-flex">
                                        ${defineHTMLForProductRedirect(product, resources, brandID)}
                                    </div>` : !productSalesPrice ? "" : `<div class="col col-sm-2 col-md-1 d-flex d-md-block justify-content-sm-center">
                                    ${defineHTMLForAddToFavoritesButton(data.addToFavoritesButton)}
                                </div>`}
                                <div class="col-11 col-sm-5 col-md-4 ct-pdp--quickView-addCTA"> 
                                    ${defineHTMLForAddToCartButton(data.addToCartButton)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 d-flex justify-content-end mt-3 mb-4">
                    <div class="col-sm-7 row no-gutters p-0 p-sm-2">
                        ${defineHTMLForProductDescription(product)}
                        ${defineHTMLForProductAdditionalInfo(product)}
                    </div>
                </div>
            </div`;

        return quickViewHTML;
    }
};

module.exports = productTemplating;
